module.exports = __webpack_public_path__ + "static/media/p0104.d024c819.png";